/** How a recipe link is read, for the privacy notice (src/components/GeminiPrivacy.tsx: setup, You and AI features' prompts). */
export const RECIPE_LINK_NOTE =
  "To import a recipe from a link, this server reads the page itself (the site sees the server, not you) and doesn't keep it: only the recipe you save, with its link.";

/** Whether Google may use what's sent to Gemini to improve its products, by the server's API key tier. */
export function geminiTrainingNote(paidTier: boolean): string {
  return paidTier
    ? "This server uses a paid Gemini API key, so Google doesn't use your data to improve its products."
    : "On Gemini's free tier, Google may use prompts to improve its products, and people at Google may read them.";
}
